export const FORM_IDS = {
  DASHBOARD: "PM_F_001",
  REQUISITIONS: "PM_F_002",
  RFQS: "PM_F_003",
  VENDORS: "PM_F_004",
  PURCHASE_ORDERS: "PM_F_005",
  INVOICES: "PM_F_006",
  BUDGETS: "PM_F_007",
  EXCHANGE_RATES: "PM_F_008",
  DELEGATIONS: "PM_F_009",
  REPORTS: "PM_F_010",
  AUDIT: "PM_F_011",
  ADMIN_USERS: "PM_F_012",
  SYSTEM_CONFIG: "PM_F_013",
  APPROVAL_CHAINS: "PM_F_014",
  CATEGORY_REVIEWERS: "PM_F_015",
  GRN: "PM_F_016",
  TRACKER: "PM_F_017",
  ITEMS: "PM_F_018",
  SERVICES: "PM_F_019",
  CONTRACTS: "PM_F_020",
  CONTRACT_CHAINS: "PM_F_021",
  ACCOUNT_CODES: "PM_F_022",
  INVENTORY: "PM_F_023",
  CREDIT_NOTES: "PM_F_024",
  INVOICE_CONFIG: "PM_F_025",
  OWNER_PORTAL: "PM_F_026",
  PROJECTS: "PM_F_027",
} as const;

export const PROCESS_IDS = {
  REQUISITION_CREATE: "PM_P_001",
  REQUISITION_HOD_REVIEW: "PM_P_002",
  REQUISITION_CATEGORY_REVIEW: "PM_P_003",
  REQUISITION_CANCEL: "PM_P_004",
  VENDOR_MANAGE: "PM_P_005",
  VENDOR_APPROVE: "PM_P_006",
  RFQ_MANAGE: "PM_P_007",
  PO_CREATE: "PM_P_008",
  PO_APPROVE: "PM_P_009",
  TRACKER_UPDATE: "PM_P_010",
  INVOICE_VERIFY: "PM_P_011",
  INVOICE_APPROVE: "PM_P_012",
  BUDGET_MANAGE: "PM_P_013",
  EXCHANGE_RATE_VIEW: "PM_P_014",
  EXCHANGE_RATE_MANAGE: "PM_P_015",
  DELEGATION_MANAGE: "PM_P_016",
  ADMIN_USER_MANAGE: "PM_P_017",
  SYSTEM_CONFIG_MANAGE: "PM_P_018",
  APPROVAL_CHAIN_MANAGE: "PM_P_019",
  CATEGORY_REVIEWER_MANAGE: "PM_P_020",
  REPORT_REQUISITION_REGISTER: "PM_P_021",
  REPORT_PO_REGISTER: "PM_P_022",
  REPORT_VENDOR_PERFORMANCE: "PM_P_023",
  REPORT_BUDGET_UTILIZATION: "PM_P_024",
  REPORT_INVOICE_AGING: "PM_P_025",
  AUDIT_VIEW: "PM_P_026",
  GRN_CREATE: "PM_P_027",
  ITEM_MANAGE: "PM_P_028",
  ITEM_APPROVE: "PM_P_029",
  SERVICE_MANAGE: "PM_P_030",
  SERVICE_APPROVE: "PM_P_031",
  SERVICE_COMPLETION_CREATE: "PM_P_032",
  ITEM_ACCOUNT_CODE_ASSIGN: "PM_P_033",
  RFQ_AWARD: "PM_P_034",
  ACCOUNT_CODE_CREATE: "PM_P_035",
  CONTRACT_VIEW: "PM_P_036",
  CONTRACT_MANAGE: "PM_P_037",
  CONTRACT_APPROVE: "PM_P_038",
  CONTRACT_CHAIN_MANAGE: "PM_P_039",
  CREDIT_NOTE_VIEW: "PM_P_040",
  CREDIT_NOTE_CREATE: "PM_P_041",
  CREDIT_NOTE_VERIFY: "PM_P_042",
  CREDIT_NOTE_APPLY: "PM_P_043",
  INVOICE_CONFIG_MANAGE: "PM_P_044",
  ACCOUNT_CODE_VIEW: "PM_P_045",
  ACCOUNT_CODE_MANAGE: "PM_P_046",
  ACCOUNT_CODE_IMPORT: "PM_P_047",
  ACCOUNT_CODE_EXPORT: "PM_P_048",
  EXPENDITURE_TYPE_MANAGE: "PM_P_049",
  INVENTORY_ADMIN_MANAGE: "PM_P_050",
  OWNER_PORTAL_VIEW: "PM_P_051",
  PROJECT_VIEW: "PM_P_052",
  PROJECT_MANAGE: "PM_P_053",
  DASHBOARD_FLEET_DAY_SECTION: "PM_P_054",
  DASHBOARD_ACTIVE_DRYDOCK_SECTION: "PM_P_055",
  DASHBOARD_PENDING_REQUISITIONS: "PM_P_056",
  DASHBOARD_ACCEPTED_REQUISITIONS: "PM_P_057",
  DASHBOARD_VENDOR_ACK: "PM_P_058",
  DASHBOARD_OVERDUE_ORDERS: "PM_P_059",
  DASHBOARD_IN_TRANSIT_POS: "PM_P_060",
  DASHBOARD_CATEGORY_REVIEW: "PM_P_061",
  DASHBOARD_PO_APPROVAL_QUEUE: "PM_P_062",
  DASHBOARD_CONTRACT_APPROVAL_QUEUE: "PM_P_063",
  DASHBOARD_VENDOR_APPROVAL_QUEUE: "PM_P_064",
  DASHBOARD_BUDGET_ALERTS: "PM_P_065",
  DASHBOARD_BUDGET_APPROVAL_QUEUE: "PM_P_066",
  DASHBOARD_INVOICE_PAYMENT_QUEUE: "PM_P_067",
  DASHBOARD_ASSIGNED_VESSELS: "PM_P_068",
  DASHBOARD_RECENT_PO_ACTIVITY: "PM_P_069",
  DASHBOARD_EXCHANGE_RATE_STATUS: "PM_P_070",
  DASHBOARD_CURRENT_EXCHANGE_RATES: "PM_P_071",
  DASHBOARD_INVOICE_CAPTURE: "PM_P_072",
  DASHBOARD_INVOICE_VERIFICATION_QUEUE: "PM_P_073",
  DASHBOARD_INVOICE_APPROVAL_QUEUE: "PM_P_074",
  DASHBOARD_INVOICE_MARK_PAID_QUEUE: "PM_P_075",
  DASHBOARD_CREDIT_NOTE_VERIFICATION_QUEUE: "PM_P_076",
  DASHBOARD_INVOICE_DUE_SOON: "PM_P_077",
  DASHBOARD_OVERDUE_INVOICES: "PM_P_078",
  DASHBOARD_PAID_INVOICES: "PM_P_079",
  DASHBOARD_APPROVED_INVOICES: "PM_P_080",
  DASHBOARD_INVOICE_DISCREPANCIES: "PM_P_081",
  DASHBOARD_RFQ_COMPARISON_QUEUE: "PM_P_082",
  DASHBOARD_PARTIAL_DELIVERIES: "PM_P_083",
  DASHBOARD_DRAFT_REQUISITIONS: "PM_P_084",
  DASHBOARD_SUBMITTED_TO_OFFICE: "PM_P_085",
  DASHBOARD_HOD_REVIEWS: "PM_P_086",
  RFQ_COMPARISON_VIEW: "PM_P_087",
  BUDGET_ALLOCATE: "PM_P_088",
  BUDGET_ACTIVATE: "PM_P_089",
  BUDGET_APPROVE: "PM_P_090",
  BUDGET_CLOSE: "PM_P_091",
  BUDGET_REOPEN: "PM_P_092",
  BUDGET_REVISION_REQUEST: "PM_P_093",
  BUDGET_REVISION_APPROVE: "PM_P_094",
  PO_DIRECT_CREWING_ACCOUNT_SCOPE: "PM_P_095",
  PO_DIRECT_UNRESTRICTED_ACCOUNT_SCOPE: "PM_P_096",
  REPORT_VENDOR_SOA: "PM_P_097",
  REPORT_SUPPLY_BY_PORT: "PM_P_098",
  REPORT_SUPPLY_BY_PORT_SEND: "PM_P_102",
  RFQ_COMPARISON_REJECT: "PM_P_099",
  RFQ_CANCEL: "PM_P_100",
  PO_CANCEL: "PM_P_101",
} as const;
